import { Modal } from '../../../components/Modal';
import { BookType } from '../api/types';
import { useEffect, useState } from 'react';
import { Button } from '../../../components/Button';
import { toast } from 'react-toastify';
import { useDeleteBookMutation } from '../api/booksApi';

type DeleteModalProps = {
  bookToDelete: BookType | null;
  onCloseModal: () => void;
};

export const useDeleteModal = ({ bookToDelete, onCloseModal }: DeleteModalProps) => {
  const [deleteBook, { isLoading: loadingDelete }] = useDeleteBookMutation();
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const onDeleteConfirmation = async () => {
    if (!bookToDelete) return;
    try {
      await deleteBook({ bookId: bookToDelete.id }).unwrap();
      setTimeout(() => onCloseModal, 300);
      toast('Book deleted successfully', { type: 'success' });
      onCloseModal();
    } catch (err) {
      toast('Error deleting book', { type: 'error' });
      console.error(err);
    }
  };
  const DeleteModal = (
    <Modal isOpen={isDeleteModalOpen} onClose={onCloseModal}>
      <div className="flex flex-col items-center">
        <p className="font-bold mt-2">Are you sure you want to delete {bookToDelete?.title}?</p>
        <img
          src={bookToDelete?.cover}
          alt={bookToDelete?.title}
          className="w-[11rem] h-[15rem] object-cover rounded-xl mt-2"
        />
        <div className="flex gap-3 mt-4 align-end">
          <Button onClick={onCloseModal} variant="secondary">
            Cancel
          </Button>
          <Button onClick={onDeleteConfirmation} btnType="danger" isLoading={loadingDelete}>
            Delete
          </Button>
        </div>
      </div>
    </Modal>
  );

  useEffect(() => {
    if (bookToDelete) {
      setIsDeleteModalOpen(true);
    } else {
      setIsDeleteModalOpen(false);
    }
  }, [bookToDelete]);

  return { DeleteModal };
};
